import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { ValidatorForm, TextValidator,SelectValidator} from 'react-material-ui-form-validator';

function daysInMonth (month, year) { // Use 1 for January, 2 for February, etc.
  if(!month || !year)
  return 0
  return new Date(year, month, 0).getDate();
}
let month_arr=[]
month_arr.push({key:1,value:'Jan'})
month_arr.push({key:2,value:'Feb'})
month_arr.push({key:3,value:'Mar'})
month_arr.push({key:4,value:'Apr'})
month_arr.push({key:5,value:'May'})
month_arr.push({key:6,value:'Jun'})
month_arr.push({key:7,value:'Jul'})
month_arr.push({key:8,value:'Aug'})
month_arr.push({key:9,value:'Sep'})
month_arr.push({key:10,value:'Oct'})
month_arr.push({key:11,value:'Nov'})
month_arr.push({key:12,value:'Dec'})


let year_arr=[]
for(let i=2000;i<2014;i++){
  year_arr.push({key:i,value:i})
}
const useStyles = makeStyles((theme) => ({
  formControl: {
marginLeft: theme.spacing(2),
minWidth:80,

  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function SimpleSelect({handleChange,dd,mm,yy}) {
  const classes = useStyles();





let day_arr=[],day_len=daysInMonth(mm,yy)
for(let i=1;i<=day_len;i++){
day_arr.push({key:i,value:i})
}
  return (
    <div style={{width:'100%'}}>

     <InputLabel style={{marginBottom:5}} shrink id="demo-simple-select-placeholder-label-label">
         Date of Birth
       </InputLabel>

 <FormControl  className={classes.formControl} style={{marginLeft:0}}>



         <SelectValidator
        fullWidth

variant="outlined"
          name="yy"
          value={yy}
          onChange={handleChange}
          label="yyyy"
          validators={['required']}
          errorMessages={['required']}
        >

          {
            year_arr.map(({key,value},i) =>{
              return(
  <MenuItem key={i} value={key}>{value}</MenuItem>
              )
            })
          }


        </SelectValidator>
  </FormControl>
  <FormControl className={classes.formControl}>


         <SelectValidator
        fullWidth
variant="outlined"

            name="mm"
          value={mm}
          onChange={handleChange}
          label="mm"
          validators={['required']}
          errorMessages={['required']}
        >

          {
            month_arr.map(({key,value},i) =>{
              return(
  <MenuItem key={i} value={key}>{value}</MenuItem>
              )
            })
          }


        </SelectValidator>
        </FormControl>
        <FormControl className={classes.formControl}>

     <SelectValidator
        fullWidth
variant="outlined"

          value={dd}
            name="dd"
          onChange={handleChange}
          label="dd"
          validators={['required']}
          errorMessages={['required']}
        >

          {
            day_arr.map(({key,value},i) =>{
              return(
  <MenuItem key={i} value={key}>{value}</MenuItem>
              )
            })
          }


        </SelectValidator>

      </FormControl>
      </div>
  );
}
